/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var TemplateType;

(function (TemplateType) {
  TemplateType["NOTIFICATION_ORDER_TRACKING"] = "notification_order_tracking";
  TemplateType["MESSAGE_OPT_IN"] = "message_opt_in";
  TemplateType["SHIPLY_FIRST_MSG_UK"] = "shiply_first_msg_uk";
  TemplateType["SHIPLY_FIRST_MSG_US"] = "shiply_first_msg_us";
  TemplateType["SHIPLY_FIRST_MSG_EU"] = "shiply_first_msg_eu";
})(TemplateType || (TemplateType = {}));